import Fasilitas1 from "../../Media/Greenbay/Greenbay (15).webp"
import Fasilitas2 from "../../Media/Greenbay/Greenbay (14).webp"
import Fasilitas3 from "../../Media/Greenbay/Greenbay (13).webp"
import Fasilitas4 from "../../Media/Greenbay/Greenbay (4).webp"
import Fasilitas5 from "../../Media/Greenbay/Greenbay (10).webp"
import Fasilitas6 from "../../Media/Greenbay/Greenbay (7).webp"
import Fasilitas7 from "../../Media/Greenbay/Greenbay (16).webp"
import Fasilitas8 from "../../Media/Greenbay/Greenbay (8).webp"


const Fasilitasimages =[
    
    Fasilitas1, Fasilitas2,Fasilitas3,Fasilitas4,Fasilitas5,Fasilitas6,Fasilitas7,Fasilitas8
    ]
    
    export default Fasilitasimages;